// TermsConsent.jsx
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import axios from "axios";

export default function TermsConsent() {
  const [agreed, setAgreed] = useState(false);
  const navigate = useNavigate();

  const handleCreateAccount = async () => {
    if (!agreed) return;
    
    try {
      const storedUser = localStorage.getItem("userData") || sessionStorage.getItem("userData");
      if(storedUser) {
        const u = JSON.parse(storedUser);
        const API_URL = window.location.hostname === 'localhost' ? 'http://localhost/api/accept_terms.php' : '/api/accept_terms.php';
        await axios.post(API_URL, { user_id: u.id });
        
        u.terms_accepted = 1;
        if(localStorage.getItem("userData")) localStorage.setItem("userData", JSON.stringify(u));
        else if(sessionStorage.getItem("userData")) sessionStorage.setItem("userData", JSON.stringify(u));
      }
      navigate("/dashboard");
    } catch(err) {
      alert("حدث خطأ أثناء الاتصال بالخادم");
    }
  };

  return (
    <div className="terms-wrapper">
      <div className="terms-background"></div>
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        className="terms-card"
      >
        <div className="terms-icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15h-2v-2h2v2zm0-4h-2V7h2v6z" fill="#0E74AB"/>
          </svg>
        </div>
        <h2 className="terms-title">مرحباً بك في Codical</h2>
        <p className="terms-subtitle">
          قبل إنشاء حسابك، يرجى مراجعة وقبول الشروط والأحكام.
        </p>

        <div className="terms-checkbox-wrapper">
          <label className="terms-checkbox-label">
            <input
              type="checkbox"
              checked={agreed}
              onChange={(e) => setAgreed(e.target.checked)}
              className="terms-checkbox"
            />
            <span className="terms-checkbox-text">
              أوافق على{" "}
              {/* تم تعديل الرابطين ليقودا إلى صفحة TermsPrivacy */}
             <Link to="/terms-privacy?type=terms">Terms & Conditions</Link>&
<Link to="/terms-privacy?type=privacy">Privacy Policy</Link>
            </span>
          </label>
        </div>

        <motion.button
          whileHover={agreed ? { scale: 1.02 } : {}}
          whileTap={agreed ? { scale: 0.98 } : {}}
          disabled={!agreed}
          onClick={handleCreateAccount}
          className={`terms-button ${agreed ? "terms-button-active" : "terms-button-disabled"}`}
        >
          Create Account
        </motion.button>

        <p className="terms-version">الإصدار 1.0 – آخر تحديث أبريل 2026</p>
      </motion.div>       

      <style>{`
        * { margin: 0; padding: 0; box-sizing: border-box; }
        .terms-wrapper { min-height: 100vh; display: flex; align-items: center; justify-content: center; position: relative; background: #f5f5f5; padding: 1rem; }
        .terms-background { position: absolute; inset: 0; background: radial-gradient(circle at 10% 20%, rgba(14, 116, 171, 0.05) 0%, rgba(0,0,0,0.02) 90%); pointer-events: none; }
        .terms-card { background: white; max-width: 480px; width: 100%; border-radius: 2rem; padding: 2rem 1.8rem; box-shadow: 0 25px 45px -12px rgba(0, 0, 0, 0.2); text-align: center; transition: all 0.3s ease; border: 1px solid rgba(0,0,0,0.05); }
        .terms-icon { margin-bottom: 1.2rem; display: flex; justify-content: center; }
        .terms-title { font-size: 1.8rem; font-weight: 700; color: #0E74AB; margin-bottom: 0.5rem; letter-spacing: -0.3px; }
        .terms-subtitle { font-size: 0.95rem; color: #4a4a4a; margin-bottom: 1.8rem; line-height: 1.5; }
        .terms-checkbox-wrapper { margin-bottom: 2rem; text-align: left; background: #fafafa; padding: 0.9rem 1rem; border-radius: 1rem; border: 1px solid #eee; }
        .terms-checkbox-label { display: flex; align-items: flex-start; gap: 0.75rem; cursor: pointer; }
        .terms-checkbox { margin-top: 0.2rem; width: 1.2rem; height: 1.2rem; accent-color: #0E74AB; cursor: pointer; }
        .terms-checkbox-text { font-size: 0.9rem; color: #1f1f1f; line-height: 1.4; }
        .terms-link { color: #0E74AB; text-decoration: none; font-weight: 600; transition: all 0.2s; border-bottom: 1px dashed rgba(14,116,171,0.3); }
        .terms-link:hover { color: #000; border-bottom-color: #000; }
        .terms-button { width: 100%; padding: 0.9rem; border-radius: 3rem; font-weight: 700; font-size: 1rem; border: none; transition: all 0.2s ease; cursor: not-allowed; margin-bottom: 1.2rem; }
        .terms-button-active { background: #0E74AB; color: white; cursor: pointer; box-shadow: 0 4px 12px rgba(14,116,171,0.3); }
        .terms-button-active:hover { background: #0a5d8a; transform: translateY(-2px); box-shadow: 0 8px 20px rgba(14,116,171,0.4); }
        .terms-button-disabled { background: #d4d4d4; color: #888; cursor: not-allowed; opacity: 0.7; }
        .terms-version { font-size: 0.7rem; color: #aaa; text-align: center; margin-top: 0.5rem; }
        @media (max-width: 480px) { .terms-card { padding: 1.5rem; } .terms-title { font-size: 1.5rem; } .terms-subtitle { font-size: 0.85rem; } }
      `}</style>
    </div>
  );
}